import { Link } from "react-router-dom";
import { Printer, DraftingCompass, Shapes, Crown, PenTool, Layers, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const PRINTER_IMG =
    "https://images.unsplash.com/photo-1642969164999-979483e21601?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHwzZCUyMHByaW50ZXIlMjB3b3JraW5nfGVufDB8fHx8MTc5MTU2MDI2MHww&ixlib=rb-4.1.0&q=85";

const CARDS = [
    {
        icon: Printer,
        title: "Impressão sob demanda",
        desc: "Você manda o modelo — ou só a ideia — escolhe material e cor, e a gente imprime e entrega.",
        span: "md:col-span-7",
        image: PRINTER_IMG,
    },
    {
        icon: DraftingCompass,
        title: "Protótipos & validação",
        desc: "Iterações rápidas para testar encaixe, forma e função antes da produção.",
        span: "md:col-span-5",
    },
    {
        icon: Shapes,
        title: "Peças personalizadas",
        desc: "Do chaveiro com nome à peça única de decoração.",
        span: "md:col-span-4",
    },
    {
        icon: Crown,
        title: "Cosplay & colecionáveis",
        desc: "Capacetes, figuras e acessórios que roubam a cena.",
        span: "md:col-span-4",
    },
    {
        icon: PenTool,
        title: "Modelagem & correção 3D",
        desc: "Ajustamos, otimizamos ou criamos o modelo 3D para você.",
        span: "md:col-span-4",
    },
    {
        icon: Layers,
        title: "Pequenas séries",
        desc: "Tiragens curtas com consistência de peça a peça — do lote piloto à prateleira da loja.",
        span: "md:col-span-8",
    },
];

export const ServicesBento = () => (
    <section id="servicos" className="py-24 md:py-32" data-testid="services-section">
        <div className="zf-container">
            <Reveal>
                <p className="zf-eyebrow">Serviços</p>
                <h2 className="mt-4 max-w-2xl font-display text-3xl font-bold uppercase leading-tight text-forge-paper md:text-5xl">
                    Impressão 3D sob medida
                </h2>
            </Reveal>

            <div className="mt-14 grid gap-6 md:grid-cols-12">
                {CARDS.map((c, i) => (
                    <Reveal key={c.title} delay={0.05 * i} className={c.span}>
                        <article
                            data-testid="service-card"
                            className="group relative h-full overflow-hidden border border-forge-line bg-forge-panel p-8 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-forge-yellow/60"
                        >
                            {c.image && (
                                <img
                                    src={c.image}
                                    alt=""
                                    loading="lazy"
                                    className="absolute inset-0 h-full w-full object-cover opacity-25 transition-opacity duration-500 group-hover:opacity-45"
                                />
                            )}
                            <div className={`relative ${c.image ? "" : "layer-lines"}`}>
                                <span className="inline-flex h-12 w-12 items-center justify-center border border-forge-yellow/40 text-forge-yellow">
                                    <c.icon className="h-5 w-5" />
                                </span>
                                <h3 className="mt-6 font-display text-lg font-bold uppercase text-forge-paper md:text-xl">
                                    {c.title}
                                </h3>
                                <p className={`mt-3 text-sm leading-relaxed ${c.image ? "text-forge-paper/80" : "text-forge-dim"}`}>
                                    {c.desc}
                                </p>
                            </div>
                        </article>
                    </Reveal>
                ))}

                <Reveal delay={0.3} className="md:col-span-4">
                    <Link
                        to="/contato"
                        data-testid="services-cta-card"
                        className="group flex h-full flex-col justify-between gap-8 bg-forge-yellow p-8 text-forge-ink transition-transform duration-300 hover:-translate-y-1"
                    >
                        <p className="font-display text-xl font-bold uppercase leading-tight md:text-2xl">
                            Tem um projeto em mente?
                        </p>
                        <span className="inline-flex items-center gap-2 font-mono text-xs font-bold uppercase tracking-[0.2em]">
                            Fale com a forja
                            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                        </span>
                    </Link>
                </Reveal>
            </div>
        </div>
    </section>
);

export default ServicesBento;
